import { formatMoney, offersByChain, toCzkMinor, type FxRates, type Offer, type Store } from '@sp/shared'
import { chainLabel, offerPack, offerPrice, offerTitle, offerValidity } from '../lib/offers.ts'
import { OfferImage } from './OfferImage.tsx'
import { Button, Label, Paragraph } from './ui.tsx'

/**
 * Akce polozky sablony po obchodech. Stitek u polozky rika jen „Jinde v akci",
 * tady je videt kde a co — u spaget se tak pozna omacka z Kauflandu v Nemecku.
 */
export function ItemOffers({
  offers,
  store,
  rates,
  terms,
  thumbs,
  onPick,
  onEditTerms,
}: {
  offers: readonly Offer[]
  /** Obchod polozky; null = bez obchodu. */
  store: Store | null
  rates: FxRates
  /** Podle ceho se akce hledaji — vlastni vyrazy, jinak nazev. */
  terms: string
  thumbs: boolean
  onPick(offer: Offer): void
  onEditTerms(): void
}) {
  if (offers.length === 0) return null
  const groups = offersByChain(offers, store?.offerChain ?? null, rates)
  return (
    <section className="stack-8 item-offers" aria-label="Slevy">
      <Label as="span">Slevy</Label>
      {store && !store.offerChain && (
        <div className="item-offers-store">
          <span className="item-offers-name">{store.name}</span>
          <span className="offer-tag">obchod položky</span>
          <span className="item-offers-empty">letáky nesledujeme</span>
        </div>
      )}
      {groups.map((group) => (
        <div key={group.chain} className="stack-4">
          <div className="item-offers-store">
            <span className="item-offers-name">{group.own && store ? store.name : chainLabel(group.chain)}</span>
            {group.own && <span className="offer-tag">obchod položky</span>}
            {group.offers.length === 0 && <span className="item-offers-empty">teď tu v akci není</span>}
          </div>
          {group.offers.map((offer) => {
            const price = offerPrice(offer)
            const old = offer.oldPriceMinor !== null ? formatMoney(offer.oldPriceMinor, offer.currency) : null
            const czk =
              offer.currency === 'CZK' || offer.priceMinor === null
                ? null
                : toCzkMinor(offer.priceMinor, offer.currency, rates)
            const meta = [offerPack(offer), offerValidity(offer)].filter(Boolean).join(' · ')
            return (
              <button key={offer.id} type="button" className="offer-group-row" onClick={() => onPick(offer)}>
                {thumbs && <OfferImage offer={offer} size="thumb" />}
                <span className="text-col">
                  <span className="offer-group-name">{offerTitle(offer)}</span>
                  {meta && <span className="text-col-sub">{meta}</span>}
                </span>
                <span className="offer-row-price">
                  {price ? <strong>{price}</strong> : <span className="meta muted">bez ceny</span>}
                  {old && <span className="offer-old">{old}</span>}
                  {czk !== null && <span className="offer-czk">{`≈ ${Math.round(czk / 100)} Kč`}</span>}
                </span>
              </button>
            )
          })}
        </div>
      ))}
      <div className="item-offers-terms">
        <Paragraph size="meta">{`Hledá se jako: ${terms}`}</Paragraph>
        <Button kind="text" compact onClick={onEditTerms}>
          Upravit
        </Button>
      </div>
    </section>
  )
}
